import React, { useEffect } from "react";
import HeroSection from "../Components/HeroSection";
import AboutShark from "../Components/AboutShark";
import Solutions from "../Components/Solutions";
import Carousel from "../Components/Reviews";
import Clients from "../Components/Clients";
import DevOpsProcess from "../Components/DevOpsProcess";
import JoinTeam from "../Components/Jointeam";
import Footer from "../Components/Footer";
import Reference from "../Components/Reference";

const scrollToHash = () => {
  const hash = window.location.hash;
  if (hash) {
    const element = document.querySelector(hash);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
};

const Home = () => {
  useEffect(() => {
    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);
    return () => window.removeEventListener("hashchange", scrollToHash);
  }, []);

  return (
    <div>
      <HeroSection />

      <section id="about">
        <AboutShark />
      </section>

      <DevOpsProcess />
      <Clients />

      <section id="solutions">
        <Solutions />
      </section>

      <section id="references">
        <Reference />
      </section>

      <Carousel />

      <section id="contact">
        <JoinTeam />
      </section>

      <Footer />
    </div>
  );
};

export default Home;


